<template>
    <div class="ui footer segment">
        <div class="ui center aligned container">
            <div class="ui horizontal inverted small divided list">
                <p>
                    Copyright © {{ current_year }} Genki Inc. All rights reserved
                </p>
            </div>
        </div>
        <div class="ui divider"></div>
        <div class="ui horizontal list">
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterBar",
    computed: {
        current_year() {
            return (new Date()).getFullYear()
        }
    }
}
</script>

<style scoped lang="scss">
</style>
